import React, { useEffect } from 'react';

const CareersView = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const positions = [
        { title: "Registered Pharmacist", type: "Full-Time", location: "Navi Mumbai", icon: "fa-user-md" },
        { title: "Delivery Executive", type: "Full-Time / Part-Time", location: "Navi Mumbai", icon: "fa-motorcycle" },
        { title: "Store Manager", type: "Full-Time", location: "Navi Mumbai", icon: "fa-store" }
    ];

    return (
        <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6">
            <div className="max-w-4xl mx-auto space-y-12">
                <div className="text-center space-y-4">
                    <h1 className="text-4xl font-bold text-slate-800">Join Our Team</h1>
                    <p className="text-lg text-slate-500">Build a rewarding career helping your local community stay healthy.</p>
                </div>

                <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100">
                    <h2 className="text-2xl font-bold text-slate-800 mb-6">Open Positions</h2>
                    
                    <div className="space-y-4">
                        {positions.map((pos, idx) => (
                            <div key={idx} className="flex flex-col sm:flex-row sm:items-center justify-between p-6 border border-slate-100 rounded-xl hover:border-sky-200 transition-colors bg-slate-50/50">
                                <div className="flex items-center space-x-4 mb-4 sm:mb-0">
                                    <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-sky-600 shadow-sm border border-slate-100">
                                        <i className={`fas ${pos.icon}`}></i>
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-slate-800">{pos.title}</h3>
                                        <div className="flex space-x-3 text-sm text-slate-500 mt-1">
                                            <span><i className="fas fa-map-marker-alt text-sky-500 mr-1"></i>{pos.location}</span>
                                            <span><i className="fas fa-clock text-sky-500 mr-1"></i>{pos.type}</span>
                                        </div>
                                    </div>
                                </div>
                                <button className="bg-sky-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-sky-700 transition-colors shadow-sm">
                                    Apply Now
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="text-center bg-sky-50 p-8 rounded-2xl border border-sky-100">
                    <h3 className="text-xl font-bold text-slate-800 mb-2">Don't see a fit?</h3>
                    <p className="text-slate-600 mb-4">We are always looking for talented people to join our mission. Send your resume to our team.</p>
                    <a href="mailto:careers@qwickmed.com" className="inline-flex items-center text-sky-600 font-bold hover:text-sky-700">
                        <i className="fas fa-envelope mr-2"></i> careers@qwickmed.com
                    </a>
                </div>
            </div>
        </div>
    );
};

export default CareersView;
